import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumb from 'components/Breadcrumb'
import Loading from 'components/Loading'
import DialogAlert from 'components/DialogAlert'

import PageTitle from './PageTitle'
import ProductTypes from './ProductTypes'
import ServiceCategory from './ServiceCategory'
import ServiceSubCategory from './ServiceSubCategory'


const List = props => (
  <div className="page-content">
    {props.isLoading && (<Loading />)}
    <Breadcrumb data={props} />
    <div className="row">
      <PageTitle />
    </div>
    <ProductTypes />
    <ServiceCategory />
    <ServiceSubCategory />
    <DialogAlert
      isOpen={props.isDeleteConfirmOpen}
      onCancel={props.setDeleteModalOpen(false)}
      onClose={props.setDeleteModalOpen(false)}
      bodyMessage={props.alertMessage}
      onSubmit={props.onConfirmDelete}
    />
    <DialogAlert
      isOpen={props.isDialogAlertOpen}
      onCancel={props.setDialogAlert(false)}
      onClose={props.setDialogAlert(false)}
      bodyMessage={props.alertMessageDialog}
      onSubmit={props.setDialogAlert(false)}
      isCancelExist={false}
    />
  </div>
)

List.defaultProps = {
  isLoading: false,
  isDeleteConfirmOpen: false,
  setDeleteModalOpen: () => { },
  onConfirmDelete: () => { },
  alertMessage: '',
  isDialogAlertOpen: false,
  alertMessageDialog: '',
  setDialogAlert: () => { },
}

List.propTypes = {
  isLoading: PropTypes.bool,
  isDeleteConfirmOpen: PropTypes.bool,
  setDeleteModalOpen: PropTypes.func,
  onConfirmDelete: PropTypes.func,
  alertMessage: PropTypes.string,
  isDialogAlertOpen: PropTypes.bool,
  alertMessageDialog: PropTypes.string,
  setDialogAlert: PropTypes.func,
}

export default List
